import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../../common/types';
import { PlanHighlight } from './planHighlights';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the plan highlights; each part uses its own slice of it */
import styles from './PlanHighlightList.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PlanHighlightItemsProps {
  highlights: PlanHighlight[];
  /** Two columns on a wide screen (the Free row). */
  twoColumns?: boolean;
}

/** The ticked lines of a plan (design plans-page a). The Free row and the paid cards use them. */
const PlanHighlightItemsComponent: React.FC<PlanHighlightItemsProps> = ({ highlights, twoColumns = false }) => (
  <ul className={clsx(styles.list, twoColumns && styles.twoColumns)}>
    {highlights.map((highlight) => (
      <li key={highlight.key} className={styles.item}>
        <FontAwesomeIcon icon={faCheck} className={styles.tick} />
        <span>
          {highlight.label}
          {highlight.value !== null && <b className={styles.value}> · {highlight.value}</b>}
        </span>
      </li>
    ))}
  </ul>
);

export const PlanHighlightItems = TypedMemo(PlanHighlightItemsComponent);
